module.exports = __webpack_public_path__ + "img/knightsigns-logo.cdaafe66.jpg";